<!-- @format -->

<div
	class="feature-spot-wrapper hmf-display-flex hmf-flex-column hmf-align-items-center hmf-justify-content-center">
	<a
		hmf-card
		[href]="link"
		[padding]="'0'"
		class="hmf-display-flex hmf-flex-column hmf-align-items-center"
		[attr.data-em]="dataEm">
		<div class="media-wrapper hmf-p-xxs hmf-sharp-radius">
			<shared-media-component-media
				[visualAssets]="visualAssets"
				[itemTitle]="'promotion-image'"></shared-media-component-media>
		</div>
		<div class="hmf-display-flex hmf-flex-column hmf-py-s">
			<div>
				<span class="feature-spot-promotionOptions hmf-header-s hmf-header-m-m">{{ displayText[promotionOptions] }}</span>
			</div>
			<div class="hmf-display-flex">
				@if (discountType === 'dollar') {
					<span
						class="feature-spot-discountDollar hmf-display-m-xs hmf-display-s"
						>$</span
					>
				}
				<span class="feature-spot-discountAmount hmf-display-m-m hmf-display-s">{{ discountAmount }}</span>
				<div
					class="hmf-display-flex hmf-flex-row hmf-align-items-flex-end hmf-justify-content-flex-end">
					@if (discountType === 'percent') {
						<span
							class="feature-spot-discountPercent hmf-display-s hmf-display-m-m hmf-mr-auto"
							>%</span
						>
					}
					@if (promotionOptions === 'upTo') {
						<span
							class="hmf-header-m-m hmf-header-s"
							>&nbsp;off</span
						>
					}
				</div>
			</div>
		</div>
	</a>
	<a
		hmf-text-link
		variant="primary"
		[linkURL]="cta?.link"
		class="hmf-pt-xs feature-spot-cta"
		[dataEm]="dataEm"
		>{{ cta?.linkTitle }}</a
	>
</div>
